import React from "react";
import * as sc from "./styles";

const Loader = ({ color, size = 24 }) => {
  return (
    <sc.Loader
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
    >
      <path d="M24 12c0-6.626-5.374-12-12-12S0 5.374 0 12m2.035 0c0-5.478 4.435-9.965 9.965-9.965S21.965 6.522 21.965 12" />
    </sc.Loader>
  );
};

export default Loader;
